import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferSpotifyToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.transferSpotifyToYoutube}
            sections={<PairTransferGuideContent sourceKey="spotify" destKey="youtube" />}
        />
    );
}
